import { useQuery } from "react-query";
import { getToken } from "../../utils/cache";

const { default: request } = require("../../utils/request");
const { useMerchantStore } = require("../../stores/merchant");
const ORG_MERCHANTS = "/organizations/merchants";

export const getMerchants = () => request.get(ORG_MERCHANTS);
export const useGetMerchants = () => {
  const { setMerchants } = useMerchantStore();
  return useQuery([ORG_MERCHANTS], getMerchants, {
    enabled: !!getToken(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    onSuccess: (data) => {
      setMerchants(data);
    },
  });
};
